<!--*
 * Modal to show how to use the application
 *
 * @author   mauricio.figueroa
 * @date     2020-08-10
 *
 * @copyright 2020 Smartmatic Corp. All Rights Reserved.
 *
 * @license
 *
 * Confidential information of Smartmatic Labs. Not for disclosure or
 * distribution prior written consent. This software contains code, techniques
 * and know-how which is confidential and proprietary to Smartmatic.
 *
 * Use of this software is subject to the terms of an end user license
 * agreement.
-->
<template>
  <AppModal :title="$t('sharedComponents.videoModal.title')" :show="show"
            show-close @on-close-click="closeHandler" @on-click-outside="closeHandler">
    <div class="row">
      <div class="col">
        <div class="body-text">{{ $t('sharedComponents.videoModal.description') }}</div>
        <div class="embed-responsive embed-responsive-16by9 video">
          <iframe
              class="embed-responsive-item"
              :src="localizedVideoSource"
              allowfullscreen
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div>
          <smtt-checkbox
              :label="$t('sharedComponents.videoModal.option')"
              @change="checkHandler"
              :checked="storedPermanentHide"
          />
        </div>
        <div v-if="showNote" class="footer-text">{{ $t('sharedComponents.videoModal.note') }}</div>
      </div>
    </div>
  </AppModal>
</template>

<script>
import getEnv from '@/utils/env';
import store from '@/store/store';
import AppModal from "@/components/SharedComponents/AppModal.vue";

export default {
  'name': 'VideoModal',
  components: { AppModal },
  'props': {
    'show': {
      'type': Boolean,
      'default': false
    },
    'showNote': {
      'type': Boolean,
      'default': true
    }
  },
  'computed': {
    'localizedVideoSource': function () {
      if (this.$store.state.currentLocale === 'en') {
        if (getEnv('VUE_APP_INTRODUCTION_VIDEO_EN')) {
          return getEnv('VUE_APP_INTRODUCTION_VIDEO_EN');
        } else {
          console.log('No introduction video for locale "en" specified')
          // placeholder video
          return 'https://player.vimeo.com/video/440178591?title=0&byline=0&portrait=0'
        }
      } else if (this.$store.state.currentLocale === 'es') {
        if (getEnv('VUE_APP_INTRODUCTION_VIDEO_ES')) {
          return getEnv('VUE_APP_INTRODUCTION_VIDEO_ES');
        } else {
          console.log('No introduction video for locale "es" specified')
          // placeholder video
          return 'https://player.vimeo.com/video/423674911?title=0&byline=0&portrait=0'
        }
      }
    }
  },
  data() {
    return {
      'storedPermanentHide': !this.$store.state.showVideoTutorial,
      'permanentHide': this.$store.state.showVideoTutorial
    }
  },
  'methods': {
    closeHandler() {
      store.commit('dontShowVideo', { 'permanentHide': this.permanentHide });
      this.$emit('dismiss');
    },
    checkHandler() {
      this.permanentHide = !this.permanentHide;
    }
  }
}
</script>

<style scoped>
.video {
  max-height: 250px;
  margin: 16px 0 46px 0;
  border-radius: 8px;
}

.body-text {
  font-size: 16px;
}

.footer-text {
  font-size: 12px;
  margin-top: 11px;
}
</style>
